import type { KeyboardEvent } from 'react';
import { useState } from 'react';

import styles from './AccordionLegacy.module.css';

import { Spacing } from '../../../styles/spacing';
import { Divider } from '../../Divider';
import { Text } from '../../Text';
import { AccordionTransition } from './AccordionTransition';
import { ToggleButton } from './ToggleButton';
import { getId } from './getId';
import type { AccordionRowItem } from './types';
import type { UseKeyboardNavigation } from './useKeyboardNavigation';

interface AccordionItemProps {
  row: AccordionRowItem;
  index: number;
  accordionId?: string;
  isSingleItem: boolean;
  handleKeyDown: UseKeyboardNavigation['handleKeyDown'];
}

export function AccordionRow(props: AccordionItemProps) {
  const [open, setOpen] = useState(props.row.open);
  const headingId = getId('label', props.accordionId, 0);
  const sectionId = getId('section', props.accordionId, props.index);
  const labelId = props.isSingleItem
    ? headingId
    : getId('label', props.accordionId, props.index);

  return (
    <div>
      <AccordionTransition in={true}>
        <Divider
          width={1}
          orientation="horizontal"
          margin={Spacing.MD}
          color="Charcoal0"
        />
      </AccordionTransition>
      <ToggleButton
        onClick={(): void => setOpen(!open)}
        onKeyDown={(e: KeyboardEvent<HTMLButtonElement>): void =>
          props.handleKeyDown(props.index, e)
        }
        open={Boolean(open)}
        sectionId={sectionId}
        id={labelId}
      >
        <Text variant="heading-22" color="Charcoal3">
          {props.row.title}
        </Text>
      </ToggleButton>

      <AccordionTransition in={Boolean(open)}>
        <section
          className={styles.content}
          id={sectionId}
          aria-label={`Content for the accordion row number ${props.index + 1}`}
        >
          {props.row.content}
        </section>
      </AccordionTransition>
    </div>
  );
}
